import { CrmTask, TaskStatus } from "../models/Task";
import api from "./api";

// ---- Tasks ----
// O backend aplica a permissão: não-admin só recebe as próprias tasks.
// userId (filtro) só tem efeito para admin.
export const getTasks = async (filter?: {
  userId?: string;
  prospectId?: string;
}): Promise<CrmTask[]> => {
  try {
    const response = await api.get(`/api/task`, { params: filter });
    return response.data ?? [];
  } catch (error) {
    console.log("error", error);
    return [];
  }
};

export const saveTask = async (task: CrmTask) => {
  try {
    return await api.post(`/api/task`, task);
  } catch (error) {
    console.log("error", error);
  }
};

export const updateTask = async (task: CrmTask) => {
  try {
    return await api.put(`/api/task/${task.id}`, task);
  } catch (error) {
    console.log("error", error);
  }
};

export const moveTask = async (
  id: string,
  move: { taskStatusId?: string | null; order: number }
) => {
  try {
    return await api.put(`/api/task/${id}/move`, move);
  } catch (error) {
    console.log("error", error);
  }
};

export const deleteTask = async (id: string) => {
  try {
    return await api.delete(`/api/task/${id}`);
  } catch (error) {
    console.log("error", error);
  }
};

// ---- Task statuses ----
export const getTaskStatuses = async (): Promise<TaskStatus[]> => {
  try {
    const response = await api.get(`/api/taskStatus`);
    return response.data ?? [];
  } catch (error) {
    console.log("error", error);
    return [];
  }
};

export const saveTaskStatus = async (status: TaskStatus) => {
  try {
    return await api.post(`/api/taskStatus`, status);
  } catch (error) {
    console.log("error", error);
  }
};

export const updateTaskStatus = async (status: TaskStatus) => {
  try {
    return await api.put(`/api/taskStatus/${status.id}`, status);
  } catch (error) {
    console.log("error", error);
  }
};

export const deleteTaskStatus = async (id: string) => {
  try {
    return await api.delete(`/api/taskStatus/${id}`);
  } catch (error) {
    console.log("error", error);
  }
};
